import { getLoginUrl, ROUTES } from '@openclassrooms/routing';
import { getActiveCountry, translate } from '@openclassrooms/translations';
import { getLocalisationConfig } from '@openclassrooms/localisation/services';

export default () => {
  const isUsUser = getActiveCountry() === 'US';
  return {
    TRAINING: {
      content: translate('main_header.training_programs.title'),
      dataEvent: 'Header|Clicked|Training',
    },
    PATHS: {
      path: ROUTES.PATH.INDEX,
      content: translate('main_header.training_programs.dropdown.paths.title'),
      dataEvent: 'click|Header|Paths',
      shouldUseHref: true,
      dataTestId: 'mainHeaderPathLink',
    },
    COURSES: {
      path: ROUTES.COURSES.INDEX,
      content: translate('main_header.training_programs.dropdown.courses.title'),
      dataEvent: 'click|Header|Courses',
      shouldUseHref: true,
    },
    OFFERS: {
      path: ROUTES.OFFERS.INDEX,
      content: translate('main_header.training_programs.dropdown.compare_offers'),
      dataEvent: 'Navigation|Redirection::Internal|Trainings comparison',
      shouldUseHref: true,
      linkAttributes: {
        rel: 'nofollow',
      },
    },
    APPRENTICESHIP: {
      shouldBeDisplayed: getLocalisationConfig('apprenticeship.isEnabled'),
      content: translate('main_header.apprenticeship_dropdown.title'),
      dataEvent: 'Header|Clicked|Apprenticeship',
      dataTestId: 'mainHeaderApprenticeshipLink',
    },
    BECOME_AN_APPRENTICE: {
      path: isUsUser ? '/us/apprenticeship' : ROUTES.APPRENTICESHIP.INDEX,
      content: translate('main_header.apprenticeship_dropdown.b2c.title'),
      dataEvent: 'Navigation|Redirection::Internal|Header apprenticeship',
    },
    CONSULT_JOB_OFFERS: {
      shouldBeDisplayed: getLocalisationConfig('apprenticeship.hasJobMarketPlace'),
      path: `${ROUTES.JOB_POSTINGS.INDEX}/apprenticeship`,
      content: translate('main_header.apprenticeship_dropdown.b2c_job.title'),
      dataEvent: 'Navigation|Redirection::Internal|Header job offers preview access',
    },
    RECRUIT_APPRENTICES: {
      path: getLocalisationConfig('page.uplift.url'),
      content: translate('main_header.apprenticeship_dropdown.business.title'),
      dataEvent: 'Navigation|Redirection::Internal|Header Uplift access',
    },
    FINALIZE_APPRENTICESHIP: {
      path: ROUTES.MY_ORGANIZATION.SHARE_CANDIDATE,
      content: translate('main_header.apprenticeship_dropdown.business_finalize.title'),
      dataEvent: 'Navigation|Redirection::Internal|Header recruiters declare a match',
    },
    FUNDING: {
      path: ROUTES.FUNDING.INDEX,
      content: translate('main_header.funding.title'),
      dataEvent: 'Header|Clicked|Funding',
      shouldUseHref: true,
      shouldBeDisplayed: getActiveCountry() === 'FR',
    },
    BUSINESS: {
      content: translate('main_header.employers'),
      dataEvent: 'click|Header|Business',
    },
    BUSINESS_DISCOVER: {
      path: ROUTES.BUSINESS.INDEX,
      content: translate('main_header.business_products.dropdown.action_discover'),
      dataEvent: 'Navigation|Redirection::Internal|Header homepage B2B access',
    },
    SPARK: {
      path: ROUTES.BUSINESS.SPARK,
      content: translate('main_header.business_products.dropdown.spark.title'),
      dataEvent: 'Button|Clicked|header-loyalty',
    },
    BOOST: {
      path: ROUTES.BUSINESS.BOOST,
      content: translate('main_header.business_products.dropdown.boost.title'),
      dataEvent: 'Button|Clicked|header-upskill',
    },
    PIVOT: {
      path: ROUTES.BUSINESS.PIVOT,
      content: translate('main_header.business_products.dropdown.pivot.title'),
      dataEvent: 'Button|Clicked|header-reskill',
    },
    UPLIFT: {
      path: getLocalisationConfig('page.uplift.url'),
      content: translate('main_header.business_products.dropdown.uplift.title'),
      dataEvent: 'Button|Clicked|header-recruit',
    },
    DISCOVER_TALENTS_B2B: {
      path: `${getLocalisationConfig('page.uplift.url')}#talents-preview`,
      content: translate('main_header.apprenticeship_dropdown.business_job.title'),
      dataEvent:
        'Navigation|Redirection::Internal|Header employer talent marketplace preview access',
    },
    SIGNIN: {
      path: getLoginUrl(false),
      content: translate('main_header.login'),
      dataEvent: 'Button|Clicked|header-signin',
      shouldUseHref: false,
    },
  };
};
